import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from 'react-helmet';
import apiService from "../apiService";
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';

function Categoryservices() {
    const { slug } = useParams();
    const [get_data, setget_data] = useState([]);
    const [cat, setcat] = useState(null);
    const [cnt, setcnt] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const defaultImage = "https://images.unsplash.com/photo-1581092160607-ee22621dd758?auto=format&fit=crop&w=600&q=80";

    useEffect(() => {
        if (slug) {
            category_service_data(slug);
        }
    }, [slug]);

    const category_service_data = async (slugVal) => {
        setIsLoading(true);
        try {
            const ary = {
                slug: slugVal,
                location: ""
            };
            const res = await apiService.get_cat_service_data(ary);
            const dt = res?.data;
            if (dt) {
                setcat(dt["main-category"] || { name: slugVal.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) });
                setcnt(dt["count"] || (dt["data"] ? dt["data"].length : 0));
                setget_data(Array.isArray(dt["data"]) ? dt["data"] : []);
            }
        } catch (err) {
            console.error("Error fetching category service data:", err);
            setcat({ name: slugVal ? slugVal.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : "Services" });
            setget_data([]);
        } finally {
            setIsLoading(false);
        }
    };

    const categoryName = cat?.name || (slug ? slug.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : "Everyday Services");

    return (
        <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Helmet>
                <title>{`${categoryName} Experts Near You | Reliep`}</title>
                <meta name="description" content={`Find top-rated ${categoryName} professionals near you. Verified ratings, upfront prices, and 30-minute booking.`} />
            </Helmet>

            <Navbar />

            {/* HEADER BANNER */}
            <section style={{
                background: 'radial-gradient(circle at 90% 10%, #fcf3fc 0%, #ffffff 70%)',
                padding: '40px 20px',
                borderBottom: '1px solid #f1e2f1'
            }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
                    <nav style={{ display: 'flex', gap: '8px', fontSize: '0.85rem', color: '#64748b', marginBottom: '14px' }}>
                        <Link to="/" style={{ color: '#850C85', textDecoration: 'none', fontWeight: 600 }}>Home</Link>
                        <span>/</span>
                        <Link to="/services" style={{ color: '#850C85', textDecoration: 'none', fontWeight: 600 }}>Services</Link>
                        <span>/</span>
                        <span style={{ color: '#0f172a', fontWeight: 700 }}>{categoryName}</span>
                    </nav>

                    <h1 style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.5rem)', fontWeight: 800, color: '#0f172a', margin: '0 0 8px' }}>
                        {categoryName} Professionals
                    </h1>
                    <p style={{ fontSize: '0.98rem', color: '#64748b', margin: 0 }}>
                        {cnt > 0 ? `Showing ${cnt} verified expert partners in your area` : 'Verified doorstep service partners ready to assist you'}
                    </p>
                </div>
            </section>

            {/* MAIN CONTENT AREA */}
            <main style={{ padding: '40px 20px 80px', flex: 1 }}>
                <div style={{
                    maxWidth: '1280px',
                    margin: '0 auto',
                    display: 'grid',
                    gridTemplateColumns: 'minmax(280px, 340px) 1fr',
                    gap: '32px',
                    alignItems: 'start'
                }}>
                    {/* LEFT SIDEBAR: FILTERS & TRUST */}
                    <aside style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {/* Summary Card */}
                        <div style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '16px',
                            border: '1px solid #f1e2f1',
                            padding: '24px',
                            boxShadow: '0 4px 16px rgba(133, 12, 133, 0.05)'
                        }}>
                            <span style={{
                                fontSize: '0.75rem',
                                fontWeight: 800,
                                color: '#850C85',
                                textTransform: 'uppercase',
                                letterSpacing: '0.8px',
                                display: 'block',
                                marginBottom: '6px'
                            }}>
                                OVERVIEW
                            </span>
                            <h2 style={{ fontSize: '1.3rem', fontWeight: 800, color: '#0f172a', margin: '0 0 10px' }}>
                                {categoryName}
                            </h2>
                            <p style={{ fontSize: '0.88rem', color: '#64748b', lineHeight: 1.5, margin: 0 }}>
                                Connect with pre-screened, certified local specialists. Enjoy transparent pricing and doorstep delivery.
                            </p>
                        </div>

                        {/* Reliep Guarantee Card */}
                        <div style={{
                            backgroundColor: '#fdf9fd',
                            borderRadius: '16px',
                            border: '1.5px solid #ebd0eb',
                            padding: '24px'
                        }}>
                            <h3 style={{ fontSize: '1.05rem', fontWeight: 800, color: '#850C85', margin: '0 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <span>🛡️</span>
                                <span>The Reliep Promise</span>
                            </h3>

                            <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                                {[
                                    { title: 'Verified Background', desc: 'Aadhaar & Police verified professionals' },
                                    { title: 'Standardized Rates', desc: 'No bargaining or surprise visit charges' },
                                    { title: 'Reliep Warranty', desc: 'Free re-work if not completely satisfied' }
                                ].map((promise, idx) => (
                                    <div key={idx} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                        <div style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            background: '#850C85',
                                            color: '#ffffff',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '0.75rem',
                                            fontWeight: 800,
                                            flexShrink: 0,
                                            marginTop: '2px'
                                        }}>
                                            ✓
                                        </div>
                                        <div>
                                            <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', display: 'block' }}>
                                                {promise.title}
                                            </span>
                                            <span style={{ fontSize: '0.78rem', color: '#64748b' }}>
                                                {promise.desc}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Help / Need Guidance */}
                        <div style={{
                            backgroundColor: '#ffffff',
                            borderRadius: '16px',
                            border: '1px solid #f1e2f1',
                            padding: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '14px'
                        }}>
                            <div style={{
                                width: '44px',
                                height: '44px',
                                borderRadius: '12px',
                                background: '#fbf2fb',
                                color: '#850C85',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '1.3rem'
                            }}>
                                💬
                            </div>
                            <div>
                                <span style={{ fontSize: '0.88rem', fontWeight: 700, color: '#0f172a', display: 'block' }}>
                                    Need help deciding?
                                </span>
                                <span style={{ fontSize: '0.78rem', color: '#64748b' }}>
                                    Call our concierge at 1800-RELIEP
                                </span>
                            </div>
                        </div>
                    </aside>

                    {/* RIGHT COLUMN: PARTNERS & SERVICE LISTINGS */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        {isLoading ? (
                            <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    border: '4px solid #f1e2f1',
                                    borderTop: '4px solid #850C85',
                                    borderRadius: '50%',
                                    animation: 'spin 0.8s linear infinite',
                                    margin: '0 auto 16px'
                                }} />
                                <p style={{ color: '#64748b', fontSize: '0.95rem' }}>Finding top partners...</p>
                                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : get_data && get_data.length > 0 ? (
                            get_data.map((gd, index) => {
                                const storeLink = gd.slug ? `/partner/${gd.slug}` : `/partner/store/${gd.emp_id}`;
                                const imageSrc = gd.featured_image && gd.featured_image.startsWith('http')
                                    ? gd.featured_image
                                    : (gd.featured_image ? `http://127.0.0.1:8000/storage/${gd.featured_image}` : defaultImage);

                                return (
                                    <div
                                        key={gd.id || index}
                                        style={{
                                            backgroundColor: '#ffffff',
                                            borderRadius: '16px',
                                            border: '1px solid #f1e2f1',
                                            padding: '20px',
                                            boxShadow: '0 4px 16px rgba(133, 12, 133, 0.05)',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            flexWrap: 'wrap',
                                            gap: '20px',
                                            alignItems: 'stretch',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.borderColor = '#850C85';
                                            e.currentTarget.style.boxShadow = '0 12px 28px rgba(133, 12, 133, 0.1)';
                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.borderColor = '#f1e2f1';
                                            e.currentTarget.style.boxShadow = '0 4px 16px rgba(133, 12, 133, 0.05)';
                                            e.currentTarget.style.transform = 'translateY(0)';
                                        }}
                                    >
                                        {/* Store Image */}
                                        <div style={{
                                            width: '220px',
                                            height: '160px',
                                            borderRadius: '12px',
                                            overflow: 'hidden',
                                            position: 'relative',
                                            backgroundColor: '#fbf2fb',
                                            flexShrink: 0
                                        }}>
                                            <img
                                                src={imageSrc}
                                                alt={gd.service_name}
                                                onError={(e) => { e.currentTarget.src = defaultImage; }}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                            <div style={{
                                                position: 'absolute',
                                                top: '8px',
                                                left: '8px',
                                                background: 'rgba(255, 255, 255, 0.95)',
                                                backdropFilter: 'blur(4px)',
                                                padding: '3px 8px',
                                                borderRadius: '6px',
                                                fontSize: '0.72rem',
                                                fontWeight: 800,
                                                color: '#28a745',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px'
                                            }}>
                                                <span>✓</span>
                                                <span>Verified</span>
                                            </div>
                                        </div>

                                        {/* Details */}
                                        <div style={{ flex: 1, minWidth: '240px', display: 'flex', flexDirection: 'column' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
                                                <div>
                                                    <h3 style={{ fontSize: '1.25rem', fontWeight: 800, color: '#0f172a', margin: '0 0 4px' }}>
                                                        {gd.service_name}
                                                    </h3>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                        <span style={{ color: '#f59e0b', fontSize: '0.9rem' }}>★</span>
                                                        <span style={{ fontSize: '0.85rem', fontWeight: 700, color: '#0f172a' }}>
                                                            {gd.ratings_average || '4.9'}
                                                        </span>
                                                        <span style={{ fontSize: '0.78rem', color: '#64748b' }}>
                                                            ({gd.ratings_count || '120+'} reviews)
                                                        </span>
                                                    </div>
                                                </div>

                                                <span style={{
                                                    fontSize: '0.8rem',
                                                    fontWeight: 700,
                                                    color: '#850C85',
                                                    background: '#fbf2fb',
                                                    padding: '4px 10px',
                                                    borderRadius: '8px',
                                                    border: '1px solid #ebd0eb'
                                                }}>
                                                    ⚡ Ready in 30 Mins
                                                </span>
                                            </div>

                                            {/* Location */}
                                            {gd.service_address && (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#64748b', fontSize: '0.85rem', marginBottom: '14px' }}>
                                                    <span>📍</span>
                                                    <span>{gd.service_address}</span>
                                                </div>
                                            )}

                                            {/* Action Buttons */}
                                            <div style={{
                                                marginTop: 'auto',
                                                display: 'flex',
                                                gap: '12px',
                                                alignItems: 'center',
                                                paddingTop: '14px',
                                                borderTop: '1px solid #f8eef8'
                                            }}>
                                                <Link
                                                    to={storeLink}
                                                    style={{
                                                        background: '#850C85',
                                                        color: '#ffffff',
                                                        padding: '10px 22px',
                                                        borderRadius: '10px',
                                                        fontWeight: 700,
                                                        fontSize: '0.88rem',
                                                        textDecoration: 'none',
                                                        boxShadow: '0 4px 12px rgba(133, 12, 133, 0.25)',
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: '6px'
                                                    }}
                                                >
                                                    <span>View Store & Book</span>
                                                    <span>→</span>
                                                </Link>

                                                <Link
                                                    to={storeLink}
                                                    style={{
                                                        border: '1px solid #cbd5e1',
                                                        background: '#ffffff',
                                                        color: '#475569',
                                                        padding: '10px 18px',
                                                        borderRadius: '10px',
                                                        fontWeight: 600,
                                                        fontSize: '0.88rem',
                                                        textDecoration: 'none'
                                                    }}
                                                >
                                                    View Rate Card
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div style={{
                                textAlign: 'center',
                                padding: '60px 20px',
                                background: '#faf8fa',
                                borderRadius: '20px',
                                border: '1.5px dashed #ebd0eb'
                            }}>
                                <div style={{
                                    width: '72px',
                                    height: '72px',
                                    borderRadius: '50%',
                                    background: '#fbf2fb',
                                    color: '#850C85',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '2rem',
                                    margin: '0 auto 16px'
                                }}>
                                    👨‍🔧
                                </div>
                                <h3 style={{ fontSize: '1.3rem', fontWeight: 800, color: '#0f172a', marginBottom: '8px' }}>
                                    No Direct Store Listings Found
                                </h3>
                                <p style={{ fontSize: '0.92rem', color: '#64748b', marginBottom: '24px', maxWidth: '440px', margin: '0 auto 24px', lineHeight: 1.5 }}>
                                    We could not find active stores for this specialty in your area right now. You can book standard doorstep technicians directly!
                                </p>
                                <Link
                                    to="/services"
                                    style={{
                                        display: 'inline-block',
                                        background: '#850C85',
                                        color: '#ffffff',
                                        padding: '12px 28px',
                                        borderRadius: '12px',
                                        fontWeight: 700,
                                        fontSize: '0.92rem',
                                        textDecoration: 'none',
                                        boxShadow: '0 4px 14px rgba(133, 12, 133, 0.25)'
                                    }}
                                >
                                    Browse All Services
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default Categoryservices;
